import moment from 'moment'
import type { DriverDailyMetricFilterEntity } from '../../domain/entities/DriverDailyMetricFilterEntity'

export class DriverDailyMetricFilterModel {
  driverId?: number
  regionId?: number
  startDate?: string
  endDate?: string
  page?: number
  limit?: number

  constructor(data: DriverDailyMetricFilterEntity) {
    this.driverId = data.driver?.id
    this.regionId = data.region?.id
    this.page = data.page !== undefined ? data.page + 1 : undefined
    this.limit = data.limit
    this.startDate = data.dateRange?.[0]
      ? moment.utc(data.dateRange[0], 'YYYY-MM-DD').startOf('day').toISOString()
      : undefined
    this.endDate = data.dateRange?.[1]
      ? moment.utc(data.dateRange[1], 'YYYY-MM-DD').endOf('day').toISOString()
      : undefined
  }
}
